import React, {PureComponent, Fragment} from 'react'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField'
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import StyleSheet from 'styles'
import InputAdornment from '@material-ui/core/InputAdornment';
import * as Icons from 'components/icons'
import {eventKeyMatches, KEYS} from 'utils'

export class Select extends PureComponent {
  state = {
    anchorEl: undefined,
    open: false,
  }

  handleClick = event => {
    if(this.props.disabled === true) {
      return
    }
    if(this.state.ignoreFocus) return
    this.setState({ open: true, anchorEl: event.currentTarget })
    event.preventDefault()
  }

  handleRequestClose = () => {
    this.setState({ open: false, ignoreFocus: true })
    if(!this.requestCloseTimer) {
      this.requestCloseTimer = setTimeout(
        () => {
          this.requestCloseTimer = null
          this.setState({ ignoreFocus: false })
        }, 1000)
    }
  }

  componentWillUnmount = () => {
    if(this.requestCloseTimer) {
      clearTimeout(this.requestCloseTimer)
    }
  }

  static defaultProps = {
    options: []
  }

  handleValueSelect = value => () => {
    this.props.onChange && this.props.onChange({target: { value }})
    this.handleRequestClose()
  }

  optionForValue = needle => {
    return this.props.options.find(({label, value}) => `${needle}` === `${value}`) || { label: ''}
  }

  render() {
    const { options, classes, ...props} = this.props
    const {menu, ...inputClasses} = (classes || {})

    const menuMinWidth = (this.state.anchorEl) ? this.state.anchorEl.clientWidth : '100%'

    const currentOption = this.optionForValue(this.props.value)
    const {label, avatar} = currentOption


    return (
      <Fragment>
        <Menu
          className={menu}
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          getContentAnchorEl={null}
          MenuListProps={{
            style: {
              minWidth: menuMinWidth,
              padding: '0px'
            }
          }}
        >
          {
            options.map(({label, value, avatar, style}, index) => {
              return (
                <MenuItem key={index} onClick={this.handleValueSelect(value)} className={styles.listItem} style={style}>
                  { avatar &&
                    <ListItemIcon>
                      {avatar}
                    </ListItemIcon>
                  }
                  <ListItemText classes={{primary: styles.listItemTextPrimary}} primary={label}/>
                </MenuItem>
              )
            })
          }
        </Menu>
        <TextField inputRef={rf => rf ? rf.readOnly = true : null}
                  onClick={this.handleClick} onFocus={this.handleClick}
                  onKeyUp={e => eventKeyMatches(e, KEYS.tab) && e.preventDefault()}
                  {...props}
                  classes={inputClasses}
                  value={label}
                  InputProps={{
                    startAdornment: (avatar) ? (<InputAdornment className={styles.startAdornment} position="end"><ListItemIcon>{avatar}</ListItemIcon></InputAdornment>) : null,
                    endAdornment: (<InputAdornment position="end">{!this.props.disabled && <Icons.ArrowDown style={{width: 12, height: 12}}/>}</InputAdornment>),
                  }}/>
      </Fragment>
    )
  }
}

const styles = StyleSheet({
  listItem: {
    '&:hover':{
      backgroundColor: '#cfcfcf'
    },
    margin: '0px',
    height: '11px',
    backgroundColor: '#e8e8e8'
  },
  startAdornment: {
    paddingBottom: '6px'
  },
  listItemTextPrimary: {
    fontSize: '12px',
    fontWeight: 500,
    color: '#464646',
    lineHeight: '15px',
    paddingTop: 0,
  }
}, {index: 1000, meta: 'TokenPortal sheet', classNamePrefix: 'TPSelect'})

export default Select